<template>
  <div class="accordion" v-bind:class="{'accordion--opened':opened}">
    <p class="accordion__title" v-on:click="toggle" >{{title}}</p>
    <div class="accordion__content" v-if="opened">
      <div class="filter-list">
        <div class="checkbox" v-for="item in items">
          <input type="checkbox" :id="'filter-'+item.Id" v-model="item.checked" @change="selected"><label :for="'filter-'+item.Id" class="filter-list__label tick-green left">{{item.Name}}</label>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "items"],
  data () {
    return {
      opened: false
    };
  },

  methods: {
    toggle () {
      this.opened = !this.opened;
    },

    selected () {
      var checked = [];

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].checked) {
          checked.push(this.items[i].Id);
        }
      }

      this.$dispatch("changed", checked);
    }
  }
};
</script>


<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .accordion{
    position: relative;

    &__title{
      @extend .button !optional;
      background: $green_dark;
      color: #fff;
      cursor: pointer;
      padding: 12px 20px 9px 18px;
      margin: 0 0 10px;
      border-radius: 3px;
    }

    &__content{
      padding: 10px 18px 18px;
    }
  }

  .filter-list{
    list-style: none;
    padding: 0;
    margin: 0;

    &__label {
      color: $green_dark;
    }
  }
</style>



// WEBPACK FOOTER //
// FilterCategoriesAccordion.vue?3a138cd2